export const DragTypes = {
  MOVABLE_FILE: "movable_file"
}
